export const MaxAllowedDifference = 5;

export const AccountErrorCodes = ["AccountInactive", "AccountLocked"];
